<template>
  <div class="container">
    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <h1>{{ $t("upload") }}</h1>
      <div class="dropbox">
        <input
          type="file"
          multiple
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          accept="application/zip"
          class="input-file"
        />
        <p v-if="isInitial">
          {{ $t("dragOrClick") }}
        </p>
        <p v-if="isSaving">{{ $t("uploading") }} {{ fileCount }}</p>
      </div>
    </form>

    <div v-if="isSuccess">
      <!-- {{ uploadedFiles.length }} -->
      <h2>{{ $t("uploadSuccess") }}</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">{{
          $t("uploadAgain")
        }}</a>
      </p>
      <ul class="list-unstyled">
        <li v-for="(item, index) in uploadedFiles" :key="index">
          <img
            :src="item.url"
            class="img-responsive img-thumbnail"
            :alt="item.originalName"
          />
        </li>
      </ul>
    </div>

    <div v-if="isFailed">
      <h2>{{ $t("uploadFail") }}</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">{{
          $t("uploadAgain")
        }}</a>
      </p>
      <pre>{{ uploadError }}</pre>
    </div>
  </div>
</template>

<script>
import { upload } from "../../services/index.js";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "upload",

  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "upload[]"
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      this.currentStatus = STATUS_SAVING;

      upload
        .upload(formData)
        .then(data => {
          // this.uploadedFiles = [].concat(x);
          this.currentStatus = STATUS_SUCCESS;

          this.$emit("onUploaded", data);
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChange(fieldName, fileList) {
      const formData = new FormData();

      if (!fileList.length) {
        return;
      }

      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      this.save(formData);
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style>
.dropbox {
  outline: 1px dashed grey;
  outline-offset: -10px;
  background: #bababa;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
  left: 0;
}

.dropbox:hover {
  background: #9a9a9a;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
